/**
 * Monograph Mapper Utility
 * Transforms various monograph API responses into a consistent format
 * for display in the monograph modal
 */

/**
 * Map pregnancy monograph response to consistent format
 * @param {Object} apiResponse - Raw API response
 * @returns {Object|null} Mapped monograph data
 */
export function mapPregnancyMonograph(apiResponse) {
  if (!apiResponse || !apiResponse.PrecautionsPregnancyMonograph) {
    return null;
  }

  const monograph = apiResponse.PrecautionsPregnancyMonograph;

  return {
    id: monograph.MonographID,
    title: 'Pregnancy Precautions Monograph',
    sections: (monograph.PrecautionsPregnancyMonographSections || []).map((section) => ({
      code: section.SectionCode?.toString() || '',
      title: section.SectionDesc || '',
      text: section.SectionText || '',
      sequence: section.SectionCode || 0,
    })),
    references: (monograph.PrecautionsPregnancyReferences || []).map((ref) => ({
      text: ref.CitationText || '',
      sequence: ref.ReferenceID || 0,
      category: ref.ReferenceTypeDesc,
    })),
  };
}

/**
 * Map drug-food monograph response to consistent format
 * @param {Object} apiResponse - Raw API response
 * @returns {Object|null} Mapped monograph data
 */
export function mapDrugFoodMonograph(apiResponse) {
  if (!apiResponse || !apiResponse.Monograph) {
    return null;
  }

  const monograph = apiResponse.Monograph;

  return {
    id: monograph.MonographID,
    title: monograph.Sections?.find((s) => s.SectionCode === 'T')?.Text || 'Drug-Food Interaction',
    sections: (monograph.Sections || []).map((section) => ({
      code: section.SectionCode || '',
      title: section.Title || '',
      text: section.Text || '',
      sequence: section.Sequence || 0,
    })),
    references: (monograph.ReferenceSections || []).map((ref) => ({
      text: ref.ReferenceText || '',
      sequence: ref.ReferenceSequence || 0,
    })),
  };
}

/**
 * Map drug-drug monograph response to consistent format
 * @param {Object} apiResponse - Raw API response
 * @returns {Object|null} Mapped monograph data
 */
export function mapDrugDrugMonograph(apiResponse) {
  if (!apiResponse || !apiResponse.Monograph) {
    return null;
  }

  const monograph = apiResponse.Monograph;

  return {
    id: monograph.MonographID,
    title: monograph.Sections?.find((s) => s.SectionCode === 'T')?.Text || 'Drug-Drug Interaction',
    sections: (monograph.Sections || []).map((section) => ({
      code: section.SectionCode || '',
      title: section.Title || '',
      text: section.Text || '',
      sequence: section.Sequence || 0,
    })),
    references: (monograph.ReferenceSections || []).map((ref) => ({
      text: ref.ReferenceText || '',
      sequence: ref.ReferenceSequence || 0,
      category: ref.ReferenceCategoryDesc,
    })),
  };
}
